import { Activity } from '../../models';
import { getActivities } from '../../services';
import * as actionTypes from './types';

export const setActivities = (value) => {
  return {
    type: actionTypes.SET_ACTIVITIES,
    value: value,
  };
};

export const setActivitiesLength = (value) => {
  return {
    type: actionTypes.SET_ACTIVITIES_LENGTH,
    value: value,
  };
};

export const setActivitiesPerPage = (value) => {
  return {
    type: actionTypes.SET_ACTIVITIES_PER_PAGE,
    value: value,
  };
};

export const setActivitiesCurrentPage = (value) => {
  return {
    type: actionTypes.SET_ACTIVITIES_CURRENT_PAGE,
    value: value,
  };
};

export const setActivitiesFilters = (value) => {
  return {
    type: actionTypes.SET_ACTIVITIES_FILTERS,
    value: value,
  };
};

export const fetchActivities =
  ({ filters = {}, page = 1, perPage = 25 } = {}) =>
  async (dispatch, getState) => {
    const { account, authenticityToken } = getState().internalReducer.internal;
    dispatch(setActivities({ data: [], error: null, loading: true }));

    try {
      const { filteredRecords, totalNumberOfRecords } = await getActivities({
        accountId: account.id,
        authToken: authenticityToken,
        filters: filters,
        page: page,
        perPage: perPage,
      });

      dispatch(
        setActivities({
          data: filteredRecords.map((activity) => new Activity(activity)),
          error: null,
          loading: false,
        }),
      );
      dispatch(setActivitiesLength({ data: totalNumberOfRecords }));
    } catch (err) {
      dispatch(setActivities({ data: [], error: err, loading: false }));
      dispatch(setActivitiesLength({ data: 0 }));
    }
  };
